import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const StaffDelete = ({
  isOpen,
  toggle,
  reload,
  staffId,
  staffName,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenStaffDeleteSuccessModal, setIsOpenStaffDeleteSuccessModal ] = useState(false);
  const [ isOpenStaffDeleteFailModal, setIsOpenStaffDeleteFailModal ] = useState(false);
  const [ messageStaffDeleteFail, setMessageStaffDeleteFail ] = useState('');

  const deleteStaff = async () => {
    try {
      setIsLoading(true);
      await api.deleteStaff({staffId});
      toggle();
      setIsOpenStaffDeleteSuccessModal(true);
      setTimeout(() => {
        setIsOpenStaffDeleteSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      toggle();
      if (!error.response) setMessageStaffDeleteFail(error.message);
      else setMessageStaffDeleteFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffDeleteFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <FontAwesomeIcon icon={faQuestionCircle} style={{fontSize:'5em', color:'orange'}}/>
          <p className='mb-0 mt-4' style={{fontSize:'15px'}}>
            {t('confirm_message.delete_staff')}
            <span className='ml-5'>
              [<span style={{fontWeight:'bold', color:'rgb(59, 125, 221)'}}>{staffName || '-'}</span>]
            </span>
          </p>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={deleteStaff}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenStaffDeleteSuccessModal}
        toggle={() => setIsOpenStaffDeleteSuccessModal(!isOpenStaffDeleteSuccessModal)}
        message={t('success_message.delete_staff')}
      />
      <ResponseFailModal
        isOpen={isOpenStaffDeleteFailModal}
        toggle={() => setIsOpenStaffDeleteFailModal(!isOpenStaffDeleteFailModal)}
        message={messageStaffDeleteFail || t('error_message.delete_staff')}
      />
    </Fragment>
  );
}

export default StaffDelete;